import { Theme } from '@mui/material';

import { AppTypographySize } from '~components/ui/typography/app-typography';

import { Breakpoint } from '~hooks/use-current-breakpoint';

export const getFluidFontSize = (
  size: Record<Breakpoint, AppTypographySize>,
  theme: Theme
): string | undefined => {
  const entries = Object.entries(size) as [Breakpoint, AppTypographySize][];
  if (entries.length !== 2) return undefined;

  const [bp1, variant1] = entries[0];
  const [bp2, variant2] = entries[1];

  const breakpointValues = theme.breakpoints.values;
  const px1 = breakpointValues[bp1];
  const px2 = breakpointValues[bp2];

  const typography = theme.typography as Record<
    AppTypographySize,
    { fontSize: number }
  >;
  const fontSize1 = typography[variant1]?.fontSize;
  const fontSize2 = typography[variant2]?.fontSize;

  if (typeof fontSize1 !== 'number' || typeof fontSize2 !== 'number')
    return undefined;

  const isAscending = px1 < px2;

  const pxMin = 375;
  const pxMax = Math.max(px1, px2);

  if (pxMax <= pxMin) return undefined;

  const sizeMinPx = isAscending ? fontSize1 : fontSize2;
  const sizeMaxPx = isAscending ? fontSize2 : fontSize1;

  if (sizeMinPx === sizeMaxPx) return undefined;

  const slope = (sizeMaxPx - sizeMinPx) / (pxMax - pxMin); // px per px
  const yAxisShift = sizeMinPx - slope * pxMin;

  const preferred = `calc(${yAxisShift.toFixed(4)}px + ${(slope * 100).toFixed(
    4
  )}vw)`;

  return `clamp(${sizeMinPx}px, ${preferred}, ${sizeMaxPx}px)`;
};
